import { CALL_API } from '../middleware/api'
import { decodePatient } from '../services/encodingService'
import { each } from 'lodash'



export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const login = (email, password) => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
			endpoint: 'login',
			body: {
				email: email,
				password: password
			},
			method: 'POST'
		}
	})
}



export const LOGOUT = 'LOGOUT'

export const logout = () => (dispatch, getState) => {
	return dispatch({ type: LOGOUT })
}



export const RECOVER_SESSION_REQUEST = 'RECOVER_SESSION_REQUEST'
export const RECOVER_SESSION_SUCCESS = 'RECOVER_SESSION_SUCCESS'
export const RECOVER_SESSION_FAILURE = 'RECOVER_SESSION_FAILURE'

export const recoverSession = () => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [RECOVER_SESSION_REQUEST, RECOVER_SESSION_SUCCESS, RECOVER_SESSION_FAILURE],
			endpoint: 'user'
		}
	})
}



export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'

export const register = (form) => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_FAILURE],
			endpoint: 'register',
			body: form,
			method: 'POST'
		}
	})
}



export const LOAD_GLOBALS_REQUEST = 'LOAD_GLOBALS_REQUEST'
export const LOAD_GLOBALS_SUCCESS = 'LOAD_GLOBALS_SUCCESS'
export const LOAD_GLOBALS_FAILURE = 'LOAD_GLOBALS_FAILURE'

export const loadGlobals = (form) => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [LOAD_GLOBALS_REQUEST, LOAD_GLOBALS_SUCCESS, LOAD_GLOBALS_FAILURE],
			endpoint: 'globals',
			method: 'GET'
		}
	})
}



export const SET_USER = 'SET_USER'

export const setUser = (user) => (dispatch, getState) => {
	return dispatch({
		type: SET_USER,
		user: user
	})
}



export const OPEN_PATIENT_RECORD = 'OPEN_PATIENT_RECORD'
export const CLOSE_PATIENT_RECORD = 'CLOSE_PATIENT_RECORD'

export const openPatientRecord = (patient) => (dispatch, getState) => {
	return dispatch({
		type: OPEN_PATIENT_RECORD,
		patient: patient
	})
}

export const closePatientRecord = () => (dispatch, getState) => {
	return dispatch({
		type: CLOSE_PATIENT_RECORD
	})
}



export const SET_LANGUAGE = 'SET_LANGUAGE'

export const setLanguage = (language) => (dispatch, getState) => {
	return dispatch({
		type: SET_LANGUAGE,
		language: language
	})
}



export const OPEN_CONSULTATION = 'OPEN_CONSULTATION'
export const CLOSE_CONSULTATION = 'CLOSE_CONSULTATION'

export const openConsultation = (consultation) => (dispatch, getState) => {
	return dispatch({
		type: OPEN_CONSULTATION,
		consultation: consultation
	})
}

export const closeConsultation = () => (dispatch, getState) => {
	return dispatch({
		type: CLOSE_CONSULTATION
	})
}



export const LOAD_PATIENTS_REQUEST = 'LOAD_PATIENTS_REQUEST'
export const LOAD_PATIENTS_SUCCESS = 'LOAD_PATIENTS_SUCCESS'
export const LOAD_PATIENTS_FAILURE = 'LOAD_PATIENTS_FAILURE'

export const loadPatients = () => (dispatch, getState) => {
	return dispatch({
		[CALL_API]: {
			types: [LOAD_PATIENTS_REQUEST, LOAD_PATIENTS_SUCCESS, LOAD_PATIENTS_FAILURE],
			endpoint: 'patients',
			method: 'GET',
			after: (data, state) => {
				return Promise.all(data.map(x => decodePatient(x))).then((res) => {
					each(res, (item) => {
						item.fullName = item.lastName + ' ' + item.firstName
						item.genderIcon = state.comboboxes.byKey.gender[item.gender].data.icon
						if (item.mainPathology) {
							item.mainPathologyName = state.comboboxes.byKey.pathology[item.mainPathology].value
						}
					})
					return res
				})
			}
		}
	})
}


// WEBPACK FOOTER //
// ./src/actions/index.js